import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { MotionConfig } from "framer-motion";
import { DemoProvider } from "./context/DemoContext";
import { Nav } from "./components/Nav";
import Hero from "./components/hero/Hero";
import StoriesSection from "./components/stories/StoriesSection";
import FeedSection from "./components/feed/FeedSection";
import AISection from "./components/ai/AISection";
import ConnectionsSection from "./components/connections/ConnectionsSection";
import PersonalAISection from "./components/personal/PersonalAISection";
import MomentsSection from "./components/moments/MomentsSection";
import { useVfx } from "./lib/vfx";
import TrustSection from "./components/trust/TrustSection";
import JoinSection from "./components/join/JoinSection";
import { Footer } from "./components/Footer";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import { useScrollFromState } from "./lib/useGoToSection";
import { PreviewModal } from "./components/feed/PreviewModal";

const Home = () => {
  useScrollFromState();
  useVfx();
  return (
  <DemoProvider>
    <div className="site">
      <Nav />
      <main>
        <Hero />
        <StoriesSection />
        <FeedSection />
        <AISection />
        <ConnectionsSection />
        <PersonalAISection />
        <MomentsSection />
        <TrustSection />
        <JoinSection />
      </main>
      <Footer />
      <PreviewModal />
    </div>
  </DemoProvider>
  );
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" toastOptions={{ className: "toast-glass" }} />
    </MotionConfig>
  );
}

export default App;
